import React from 'react';
import ReactModal from 'react-modal';

import './Modal.scss';
import { Button } from '../Buttons';
import { IconButton } from '@citygross/components';
import { Icons } from '@citygross/icons';

type TModal = {
  buttonText: string;
  children: React.ReactNode;
  closeModal: () => void;
  isOpen: boolean;
  modalStyles?: string;
  onButtonClick?: () => void;
  overlayStyles?: string;
};

const Modal = ({
  buttonText,
  children,
  closeModal,
  isOpen,
  modalStyles,
  onButtonClick,
  overlayStyles
}: TModal) => (
  <ReactModal
    ariaHideApp={false}
    className={modalStyles}
    isOpen={isOpen}
    onRequestClose={closeModal}
    overlayClassName={overlayStyles}
  >
    <div className="c-newModal">
      <div className="c-newModal__close">
        <IconButton
          aria-label="Stäng"
          borderRadius={100}
          color="lightest"
          icon={<Icons.Cross />}
          onClick={() => (onButtonClick ? onButtonClick() : closeModal())}
        />
      </div>

      <div className="c-newModal__body">{children}</div>

      <div className="c-newModal__buttonContainer">
        <Button
          buttonType="blue"
          lg
          onClick={() => (onButtonClick ? onButtonClick() : closeModal())}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  </ReactModal>
);

Modal.defaultProps = {
  isOpen: false,
  closeModal: () => {},
  modalStyles: 'NewModal',
  overlayStyles: 'Overlay'
};

export default Modal;
